(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
// --- LOCALSTORAGE DE DATOS DE PERSONAS ---
function printPersonasLocalStorage() {
  console.log("=== LocalStorage de personas ===");
  Object.keys(localStorage).forEach(function(key) {
    if (key.startsWith('personas_')) {
      try { console.log(key, JSON.parse(localStorage.getItem(key))); }
      catch(e) { console.log(key, localStorage.getItem(key)); }
    }
  });
  console.log("=== Fin de LocalStorage de personas ===");
}

function syncPersonasLocalStorageWithCart() {
  return fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const itemsByVariantId = {};
      const cartKeys = [];
      cart.items.forEach(item => {
        itemsByVariantId[item.id.toString()] = item;
        cartKeys.push(item.key);
      });

      Object.keys(localStorage).forEach(lsKey => {
        if (lsKey.startsWith('personas_pend_')) {
          const variantId = lsKey.replace('personas_pend_', '');
          const cartItem = itemsByVariantId[variantId];
          if (cartItem) {
            const targetKey = 'personas_' + cartItem.key;
            localStorage.setItem(targetKey, localStorage.getItem(lsKey));
            localStorage.removeItem(lsKey);
            console.log('[Personas] Asociado', lsKey, '=>', targetKey);
          } else {
            localStorage.removeItem(lsKey);
          }
        }
      });

      Object.keys(localStorage).forEach(lsKey => {
        if (lsKey.startsWith('personas_') && !lsKey.startsWith('personas_pend_')) {
          const itemKey = lsKey.replace('personas_', '');
          if (!cartKeys.includes(itemKey)) {
            localStorage.removeItem(lsKey);
          }
        }
      });

      printPersonasLocalStorage();
    })
    .catch(err => console.error('[Personas] Error sync:', err));
}

// --- REINICIO Y LÓGICA DEL FORMULARIO DE FACTURACIÓN ---
function resetInvoiceForm() {
  const requiresInvoiceSelect = document.getElementById('requires-invoice');
  const invoiceForm = document.getElementById('invoice-form');
  const basicFields = document.getElementById('basic-fields');
  const fullInvoiceFields = document.getElementById('full-invoice-fields');
  const studentIdField = document.getElementById('student-id-field');
  const formActions = document.getElementById('form-actions');

  if (invoiceForm) {
    invoiceForm.querySelectorAll('input,select,textarea').forEach(function(field) {
      if (field.type === "checkbox" || field.type === "radio") field.checked = false;
      else field.value = '';
    });
    invoiceForm.reset();
  }
  if (requiresInvoiceSelect) requiresInvoiceSelect.value = '';
  if (basicFields) basicFields.style.display = 'block';
  if (fullInvoiceFields) fullInvoiceFields.style.display = 'none';
  if (formActions) formActions.style.display = 'flex';
  if (studentIdField) studentIdField.style.display = 'none';
  setFieldsRequired(true, false);
}

function setFieldsRequired(basicRequired, fullRequired) {
  const basicInputs = ['invoice-name', 'invoice-birth-date', 'invoice-student-type'];
  basicInputs.forEach(id => {
    const field = document.getElementById(id);
    if (field) {
      if (basicRequired) field.setAttribute('required', 'required');
      else field.removeAttribute('required');
    }
  });
  const fullInputs = [
    'invoice-rfc', 'invoice-postal-code', 'invoice-social-reason',
    'invoice-email', 'invoice-tax-regime', 'invoice-use', 'invoice-payment-method'
  ];
  fullInputs.forEach(id => {
    const field = document.getElementById(id);
    if (field) {
      if (fullRequired) field.setAttribute('required', 'required');
      else field.removeAttribute('required');
    }
  });
}

function applyInvoiceVisibility() {
  const requiresInvoiceSelect = document.getElementById('requires-invoice');
  const basicFields = document.getElementById('basic-fields');
  const fullInvoiceFields = document.getElementById('full-invoice-fields');
  const formActions = document.getElementById('form-actions');
  if (!requiresInvoiceSelect || !basicFields || !fullInvoiceFields) return;
  basicFields.style.display = 'block';
  const value = requiresInvoiceSelect.value;
  if (value === 'si') {
    fullInvoiceFields.style.display = 'block';
    formActions && (formActions.style.display = 'flex');
    setFieldsRequired(true, true);
  } else {
    fullInvoiceFields.style.display = 'none';
    formActions && (formActions.style.display = 'flex');
    setFieldsRequired(true, false);
  }
}

function initFacturacionForm(forceReset=false) {
  const requiresInvoiceSelect = document.getElementById('requires-invoice');
  const clearBtn = document.getElementById('clear-invoice-form');
  const invoiceForm = document.getElementById('invoice-form');

  if (requiresInvoiceSelect) {
    requiresInvoiceSelect.onchange = null;
    requiresInvoiceSelect.removeEventListener('change', window._iadaInvoiceChangeListener || (()=>{}));
  }
  if (clearBtn) clearBtn.onclick = null;

  if (forceReset) resetInvoiceForm();

  if (requiresInvoiceSelect) {
    window._iadaInvoiceChangeListener = function() {
      applyInvoiceVisibility();
    };
    requiresInvoiceSelect.addEventListener('change', window._iadaInvoiceChangeListener);
  }
  applyInvoiceVisibility();

  if (clearBtn) {
    clearBtn.onclick = function() {
      resetInvoiceForm();
    };
  }

  // Validación en vivo
  document.querySelectorAll('#invoice-form [required]').forEach(function(input) {
    input.addEventListener('input', function() {
      if (this.value.trim()) clearFieldError(this);
    });
    input.addEventListener('change', function() {
      if (this.value.trim()) clearFieldError(this);
    });
  });

  // Validaciones RFC, email y CP
  const rfcInput = document.getElementById('invoice-rfc');
  if (rfcInput) rfcInput.addEventListener('input', function() { this.value = this.value.toUpperCase(); });
  const emailField = document.getElementById('invoice-email');
  if (emailField) {
    emailField.addEventListener('input', function() {
      if (!this.value.trim() || !isValidEmail(this.value.trim())) showFieldError(this, 'Coloca un correo electrónico válido');
      else clearFieldError(this);
    });
  }
  const cpField = document.getElementById('invoice-postal-code');
  if (cpField) {
    cpField.addEventListener('input', function() {
      if (!this.value.trim() || !isValidPostalCode(this.value.trim())) showFieldError(this, 'El código postal debe ser de 5 números');
      else clearFieldError(this);
    });
  }

  // --- FUNCIONES DE VALIDACIÓN ---
  function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }
  function isValidPostalCode(cp) { return /^[0-9]{5}$/.test(cp); }
  function showFieldError(field, msg) {
    if (!field) return;
    field.classList.add('error');
    let help = field.parentElement.querySelector('.form-help');
    if (!help) {
      help = document.createElement('small');
      help.className = 'form-help';
      field.parentElement.appendChild(help);
    }
    help.textContent = msg;
    field.parentElement.classList.add('error');
  }
  function clearFieldError(field) {
    if (!field) return;
    field.classList.remove('error');
    let help = field.parentElement.querySelector('.form-help');
    if (help && help.textContent !== '' && !help.hasAttribute('data-original')) help.textContent = '';
    field.parentElement.classList.remove('error');
  }
  function validateRequired(id, msg, focusIfError) {
    const field = document.getElementById(id);
    if (!field || !field.offsetParent) return true;
    if (!field.value.trim()) {
      showFieldError(field, msg);
      if (focusIfError) field.focus();
      return false;
    }
    clearFieldError(field);
    return true;
  }
  function showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `invoice-notification invoice-notification--${type}`;
    notification.innerHTML = `<div class="invoice-notification__content">
      ${type === 'success'
        ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20,6 9,17 4,12"/></svg>'
        : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>'}
      <span>${message}</span>
    </div>`;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#10b981' : '#ef4444'};
      color: white;
      padding: 16px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 10001;
      transform: translateX(100%);
      transition: transform 0.3s ease;
    `;
    notification.querySelector('.invoice-notification__content').style.cssText = `
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 500;
    `;
    document.body.appendChild(notification);
    setTimeout(() => { notification.style.transform = 'translateX(0)'; }, 100);
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => { if (document.body.contains(notification)) document.body.removeChild(notification); }, 300);
    }, 4000);
  }

  // --- VALIDACIÓN Y ENVÍO ---
  window.checkoutHandler = function(e) {
    const invoiceForm = document.getElementById('invoice-form');
    if (!invoiceForm) return;

    let valid = true;
    let focusSet = false;
    const requiereFactura = document.getElementById('requires-invoice');
    if (!requiereFactura.value) {
      showFieldError(requiereFactura, 'Selecciona si requieres factura');
      valid = false;
      if (!focusSet) { requiereFactura.focus(); focusSet = true; }
    } else {
      clearFieldError(requiereFactura);
    }

    // Validaciones básicas y completas...
    valid = validateRequired('invoice-name', 'Coloca tu nombre completo', !focusSet) && valid;
    valid = validateRequired('invoice-birth-date', 'Coloca tu fecha de nacimiento', !focusSet) && valid;
    valid = validateRequired('invoice-student-type', 'Selecciona tu tipo de estudiante', !focusSet) && valid;

    if (requiereFactura.value === 'si') {
      valid = validateRequired('invoice-rfc', 'Coloca tu RFC', !focusSet) && valid;
      valid = validateRequired('invoice-postal-code', 'Coloca tu código postal', !focusSet) && valid;
      valid = validateRequired('invoice-social-reason', 'Coloca tu razón social', !focusSet) && valid;
      valid = validateRequired('invoice-email', 'Coloca tu correo electrónico', !focusSet) && valid;
      valid = validateRequired('invoice-tax-regime', 'Selecciona tu régimen fiscal', !focusSet) && valid;
      valid = validateRequired('invoice-use', 'Selecciona el uso del CFDI', !focusSet) && valid;
      valid = validateRequired('invoice-payment-method', 'Selecciona el método de pago', !focusSet) && valid;
    }

    if (!valid) {
      e.preventDefault();
      showNotification('Por favor, completa todos los campos obligatorios.', 'error');
      return;
    }

    e.preventDefault();

    // --- Paso 1: sincronizar localStorage con carrito
    syncPersonasLocalStorageWithCart().then(() => {
      // --- Paso 2: esperar y reconstruir nota y atributos
      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            /* --- Nota global con Personas --- */
            let nota = '';
            cart.items.forEach(item => {
              const personasData = localStorage.getItem('personas_' + item.key);
              if (personasData) {
                try {
                  const data = JSON.parse(personasData);
                  nota += `Programa: ${data.producto}\n`;
                  data.personas.forEach((persona, idx) => {
                    nota += `Persona ${idx + 1}:\n`;
                    if (persona.nombre) nota += `  Nombre: ${persona.nombre}\n`;
                    if (persona.edad) nota += `  Edad: ${persona.edad}\n`;
                    if (persona.genero) nota += `  Género: ${persona.genero}\n`;
                    if (persona.correo) nota += `  Correo: ${persona.correo}\n`;
                    if (persona.ocupacion) nota += `  Ocupación: ${persona.ocupacion}\n`;
                  });
                  nota += '\n';
                } catch(e) {
                  console.warn('[Personas] JSON inválido en', 'personas_' + item.key, e);
                }
              }
            });
            nota = nota.trim();

            /* --- Atributos de Facturación (mapeo limpio) --- */
            let atributos = {};
            const formData = new FormData(invoiceForm);
            

            if (formData.get("requires_invoice") === "si") {
              atributos["rfc"] = formData.get("invoice_rfc") || "";
              atributos["codigoPostal"] = formData.get("invoice_postal_code") || "";
              atributos["razonSocial"] = formData.get("invoice_social_reason") || "";
              atributos["email"] = formData.get("invoice_email") || "";
              atributos["regimenFiscal"] = formData.get("invoice_tax_regime") || "";
              atributos["usoCfdi"] = formData.get("invoice_use") || "";
              atributos["formaPago"] = formData.get("invoice_payment_method") || "";
            }
            atributos["facturar"] = formData.get("requires_invoice") || "NO";
atributos["nombreAlumno"] = formData.get("invoice_name") || "";
atributos["fechaNacimiento"] = formData.get("invoice_birth_date") || "";
atributos["esAlumnoUA"] = formData.get("invoice_student_type") || "";

            console.log("Nota final:", nota);
            console.log("Atributos finales:", atributos);

            return fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                note: nota || 'Sin personas registradas',
                attributes: atributos
              })
            }).then(r => {
              if (!r.ok) throw new Error('Falló update cart');
              return r.json();
            }).then(() => {
              window.location.href = '/checkout';
            });
          })
          .catch(err => {
            console.error('[Personas] Error construyendo/enviando nota:', err);
            window.location.href = '/checkout';
          });
      }, 800);
    });
  };
}

// --- MUTATION OBSERVER ---
var cartSection = document.querySelector('form#cart') || document.querySelector('main-cart');
if (cartSection) {
  var observer = new MutationObserver(function(mutations) {
    var found = false;
    mutations.forEach(function(m) {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(function(n) {
          if (n.nodeType === 1 && (n.id === 'invoice-form' || n.querySelector?.('#invoice-form'))) {
            found = true;
          }
        });
      }
    });
    if (found) setTimeout(() => initFacturacionForm(true), 50);
  });
  observer.observe(cartSection, { childList: true, subtree: true });
}

// --- Delegación para botón checkout ---
document.addEventListener('click', function(e) {
  var btn = e.target.closest('button[type="submit"][form="cart"][name="checkout"]');
  if (btn) checkoutHandler(e);
});

// --- INICIALIZA AL CARGAR ---
document.addEventListener('DOMContentLoaded', function(){
  syncPersonasLocalStorageWithCart();
  initFacturacionForm(true);
});

// --- SINCRONIZAR AL CAMBIAR CANTIDADES DE CARRITO ---
(function() {
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const promise = originalFetch.apply(this, arguments);
    if (typeof url === 'string' && url.includes('/cart/')) {
      promise.then(response => {
        if (response.ok) {
          setTimeout(() => {
            syncPersonasLocalStorageWithCart();
            initFacturacionForm(true);
          }, 500);
        }
        return response;
      });
    }
    return promise;
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var productForm = document.getElementById('product-form-template--16845637419071__main') 
    || document.getElementById('product-form-template--16865071792191__main')
    || document.querySelector('form[action="/cart/add"], form[data-product-form], form[id^="product-form"]');
  var addToCartBtn = document.querySelector('button[name="add"]');
  var personasModal = document.getElementById('personas-modal');
  var personasForm = document.getElementById('personas-form');
  var personasFields = document.getElementById('personas-fields');
  var closeBtn = document.querySelector('.personas-modal__close');
  var overlay = document.querySelector('.personas-modal__overlay');
  var modalActive = false;

  // Encuentra todos los selects relevantes
  function findPersonasSelectors() {
    var byClass = Array.prototype.slice.call(document.querySelectorAll('select.js-num-personas'));
    var byNameContains = Array.prototype.slice.call(document.querySelectorAll('select[name*="Número de personas"]'));
    var byIdPattern = Array.prototype.slice.call(document.querySelectorAll('select[id^="Option-template"]'));
    var all = byClass.concat(byNameContains, byIdPattern);
    return all.filter(function (el, idx) { return all.indexOf(el) === idx; });
  }

  // Selecciona el selector preferido: dentro del form > visible > primero
  function getPreferredSelector() {
    var sels = findPersonasSelectors();
    if (!sels.length) return null;
    if (productForm) {
      for (var i = 0; i < sels.length; i++) {
        if (productForm.contains(sels[i])) return sels[i];
      }
    }
    for (var j = 0; j < sels.length; j++) {
      if (sels[j].offsetParent !== null) return sels[j];
    }
    return sels[0];
  }

  // Convierte el valor del select a cantidad
  function getPersonasQtyFromValue(value) {
    if (value === undefined || value === null) return 1;
    value = String(value).trim();
    var map = {
      "Una": 1, "Una persona": 1, "1": 1, "uno": 1,
      "Dos": 2, "2": 2, "dos": 2,
      "Tres": 3, "3": 3, "tres": 3,
      "Cuatro": 4, "4": 4, "cuatro": 4,
      "Cinco": 5, "5": 5, "cinco": 5,
      "Seis": 6, "6": 6, "seis": 6,
      "Siete": 7, "7": 7, "siete": 7,
      "Ocho": 8, "8": 8, "ocho": 8,
      "Nueve": 9, "9": 9, "nueve": 9,
      "Diez": 10, "10": 10, "diez": 10
    };
    if (map[value] !== undefined) return map[value];
    var parsed = parseInt(value, 10);
    if (!isNaN(parsed)) return parsed;
    var digits = value.match(/\d+/);
    if (digits) return parseInt(digits[0], 10);
    return 1;
  }

  // Renderiza los campos en el modal según qty
  function renderPersonasFields(qty) {
    personasFields.innerHTML = '';
    qty = Math.max(1, Math.min(50, qty)); // seguridad: límite razonable
    for (var i = 0; i < qty; i++) {
      var html = ''
        + '<div class="persona-fields">'
        + '<h4>Persona ' + (i + 1) + (i === 0 ? ' (Principal)' : '') + '</h4>'
        + '<label>Nombre completo *</label>'
        + '<input type="text" name="nombre_' + i + '" required>'
        + '<label>Edad *</label>'
        + '<input type="number" name="edad_' + i + '" min="0" required>'
        + '<label>Género *</label>'
        + '<select name="sexo_' + i + '" required>'
        + '<option value="">Selecciona...</option>'
        + '<option value="Femenino">Femenino</option>'
        + '<option value="Masculino">Masculino</option>'
        + '<option value="Otro">Otro</option>'
        + '</select>';
      if (i === 0) html += '<label>Correo electrónico *</label><input type="email" name="correo_' + i + '" required>';
      html += '<label>¿A qué se dedica? *</label>'
        + '<input type="text" name="dedica_' + i + '" required>'
        + '</div>';
      personasFields.insertAdjacentHTML('beforeend', html);
    }
  }

  // Adjunta listeners a todos los selects detectados (evita duplicados)
  function attachPersonasSelectorListeners() {
  var sels = findPersonasSelectors();
  if (!sels.length) return;
  sels.forEach(function (sel) {
    if (sel.dataset.personasAttached) return;
    
    // Evento change para abrir el modal si corresponde
    sel.addEventListener('change', function (e) {
      var qty = getPersonasQtyFromValue(e.target.value);
      if (personasModal && qty >= 2 && !modalActive) {
        abrirModalPersonas();
      } else if (personasModal && personasModal.style.display === 'flex') {
        renderPersonasFields(qty);
      }
    });
    sel.dataset.personasAttached = '1';
  });
}

  function abrirModalPersonas() {
    var sel = getPreferredSelector();
    var personasQty = getPersonasQtyFromValue(sel ? sel.value : '');
    if (personasQty < 2) return;
    renderPersonasFields(personasQty);
    personasModal.style.display = 'flex';
    modalActive = true;
    if (addToCartBtn) addToCartBtn.disabled = true;
  }

  // Inicial
  attachPersonasSelectorListeners();

  // Click en Añadir al carrito (intercepta si corresponde)
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      var sel = getPreferredSelector();
      var personasQty = getPersonasQtyFromValue(sel ? sel.value : '');
      if (personasQty >= 2) {
        e.preventDefault();
        abrirModalPersonas();
        return false;
      }
    }, true);
  }

  // Submit del formulario del producto (por si hay otros botones)
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      var sel = getPreferredSelector();
      var personasQty = getPersonasQtyFromValue(sel ? sel.value : '');
      if (modalActive || (personasQty >= 2)) {
        e.preventDefault();
        abrirModalPersonas();
        return false;
      }
    }, true);
  }

  // Cerrar modal
  [closeBtn, overlay].forEach(function (el) {
    if (!el) return;
    el.addEventListener('click', function () {
      personasModal.style.display = 'none';
      personasFields.innerHTML = '';
      modalActive = false;
      if (addToCartBtn) addToCartBtn.disabled = false;
      setTimeout(attachPersonasSelectorListeners, 100);
    });
  });

  // Submit del modal: valida, arma nota y envía el form original
  if (personasForm) {
    personasForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var sel = getPreferredSelector();
      var personasQty = getPersonasQtyFromValue(sel ? sel.value : '');
      var valid = true;

      personasForm.querySelectorAll('input,select').forEach(function (input) {
        if (!String(input.value || '').trim()) {
          input.style.borderColor = '#e00';
          valid = false;
        } else {
          input.style.borderColor = '#ccc';
        }
        if (input.type === 'email') {
          var re = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
          if (!re.test(input.value.trim())) {
            input.style.borderColor = '#e00';
            valid = false;
          }
        }
      });

      if (!valid) return;

      var personas = [];
      for (var i = 0; i < personasQty; i++) {
        personas.push({
          nombre: personasForm['nombre_' + i].value,
          edad: personasForm['edad_' + i].value,
          genero: personasForm['sexo_' + i].value,
          correo: i === 0 ? personasForm['correo_' + i].value : '',
          ocupacion: personasForm['dedica_' + i].value
        });
      }

      // Obtener información del producto para guardarla con los datos
      var productTitle = document.querySelector('h1.product__title')?.textContent.trim() || 
                         document.querySelector('.product__title')?.textContent.trim() || 
                         'Producto';
      var variantId = '';
      
      try {
        if (productForm) {
          var variantInput = productForm.querySelector('select[name="id"], input[name="id"][checked], input[name="id"][type="hidden"]');
          if (variantInput) {
            variantId = variantInput.value;
          }
        }
      } catch (e) {
        console.error('Error al obtener variant ID:', e);
      }

      // Guardar en localStorage con información para identificar el producto
      var personasData = {
        producto: productTitle,
        variant_id: variantId,
        timestamp: new Date().toISOString(),
        personas: personas
      };
      
      // Guardar temporalmente con variant_id hasta que tengamos la key del carrito
      if (variantId) {
        localStorage.setItem('personas_pend_' + variantId, JSON.stringify(personasData));
      }

      personasModal.style.display = 'none';
      modalActive = false;
      if (addToCartBtn) addToCartBtn.disabled = false;
      if (productForm) productForm.submit();
    });
  }

  // Observador: re-atar listeners si el theme re-renderiza selects dinámicamente
  var observer = new MutationObserver(function () { attachPersonasSelectorListeners(); });
  observer.observe(document.body, { childList: true, subtree: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc-bar"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Elementos del sticky
  var productFormSticky = document.getElementById('product-form-sticky-atc-bar');
  var stickyAddToCartBtn = productFormSticky ? productFormSticky.querySelector('button[name="add"]') : document.querySelector('button[name="add"]');
  var personasModal = document.getElementById('personas-modal');
  var personasForm = document.getElementById('personas-form');
  var personasFields = document.getElementById('personas-fields');
  var closeBtn = document.querySelector('.personas-modal__close');
  var overlay = document.querySelector('.personas-modal__overlay');

  // Estado
  var modalActive = false;
  var activeForm = null;

  // Busca el selector del sticky (prioriza selects dentro del formulario sticky)
  function findStickySelector() {
    if (productFormSticky) {
      var selInSticky = productFormSticky.querySelector('select.sticky-atc-bar__variant-select, select[name*="Número de personas"], select[id^="Option-template"]');
      if (selInSticky) return selInSticky;
    }
    // fallback: cualquier select que coincida con patrones
    return document.querySelector('select.sticky-atc-bar__variant-select, select[name*="Número de personas"], select[id^="Option-template"]');
  }

  // Obtener el texto visible de la opción seleccionada (porque en el sticky el value es el variant id)
  function getSelectorText(sel) {
    if (!sel) return '';
    try {
      if (sel.options && sel.selectedIndex >= 0) {
        return String(sel.options[sel.selectedIndex].text || sel.value || '').trim();
      }
    } catch (e) {}
    return String(sel.value || '').trim();
  }

  // Convierte texto/valor a número (acepta "Tres", "3", "Cuatro", etc.)
  function getPersonasQtyFromText(text) {
    if (text === undefined || text === null) return 1;
    text = String(text).trim();
    if (!text) return 1;
    var map = {
      "Una": 1, "Una persona": 1, "1": 1, "uno": 1, "una": 1,
      "Dos": 2, "2": 2, "dos": 2,
      "Tres": 3, "3": 3, "tres": 3,
      "Cuatro": 4, "4": 4, "cuatro": 4,
      "Cinco": 5, "5": 5, "cinco": 5,
      "Seis": 6, "6": 6, "seis": 6,
      "Siete": 7, "7": 7, "siete": 7,
      "Ocho": 8, "8": 8, "ocho": 8,
      "Nueve": 9, "9": 9, "nueve": 9,
      "Diez": 10, "10": 10, "diez": 10
    };
    if (map[text] !== undefined) return map[text];
    var digits = text.match(/\d+/);
    if (digits) return parseInt(digits[0], 10);
    return 1;
  }

  function getPersonasQtyFromSelector(sel) {
    if (!sel) return 1;
    var txt = getSelectorText(sel);
    return getPersonasQtyFromText(txt);
  }

  // Genera los campos en el modal según qty
  function renderPersonasFields(qty) {
    personasFields.innerHTML = '';
    qty = Math.max(1, Math.min(50, qty)); // seguridad: tope razonable
    for (var i = 0; i < qty; i++) {
      var html = ''
        + '<div class="persona-fields">'
        + '<h4>Persona ' + (i + 1) + (i === 0 ? ' (Principal)' : '') + '</h4>'
        + '<label>Nombre completo *</label>'
        + '<input type="text" name="nombre_' + i + '" required>'
        + '<label>Edad *</label>'
        + '<input type="number" name="edad_' + i + '" min="0" required>'
        + '<label>Género *</label>'
        + '<select name="sexo_' + i + '" required>'
        + '<option value="">Selecciona...</option>'
        + '<option value="Femenino">Femenino</option>'
        + '<option value="Masculino">Masculino</option>'
        + '<option value="Otro">Otro</option>'
        + '</select>';
      if (i === 0) html += '<label>Correo electrónico *</label><input type="email" name="correo_' + i + '" required>';
      html += '<label>¿A qué se dedica? *</label>'
        + '<input type="text" name="dedica_' + i + '" required>'
        + '</div>';
      personasFields.insertAdjacentHTML('beforeend', html);
    }
  }

  // Adjunta listener al selector sticky (evita duplicados)
  function attachStickySelectorListener() {
    var sel = findStickySelector();
    if (!sel) return;
    if (sel.dataset.personasAttached === '1') return;
    sel.addEventListener('change', function () {
      if (personasModal && personasModal.style.display === 'flex') {
        var qty = getPersonasQtyFromSelector(sel);
        renderPersonasFields(qty);
      }
    });
    sel.dataset.personasAttached = '1';
  }

  // Abre modal leyendo cantidad del selector del sticky (o visible)
  function abrirModalPersonasSticky() {
    var sel = findStickySelector();
    var qty = getPersonasQtyFromSelector(sel);
    if (qty < 2) return;
    renderPersonasFields(qty);
    personasModal.style.display = 'flex';
    modalActive = true;
    // marcar form activo como el sticky (si existe) para luego enviar
    activeForm = productFormSticky || findStickySelector() && findStickySelector().closest && findStickySelector().closest('form') || document.querySelector('form[action="/cart/add"]');
    if (activeForm) {
      var btn = activeForm.querySelector('button[name="add"]');
      if (btn) btn.disabled = true;
    }
  }

  // Intercepta el click del botón Añadir del sticky
  if (stickyAddToCartBtn) {
    stickyAddToCartBtn.addEventListener('click', function (e) {
      var sel = findStickySelector();
      var qty = getPersonasQtyFromSelector(sel);
      if (qty >= 2) {
        e.preventDefault();
        abrirModalPersonasSticky();
        return false;
      }
      // si qty < 2, dejar comportamiento por defecto
    }, true);
  }

  // Intercepta envío del form sticky por submit (por si envían directo)
  if (productFormSticky) {
    productFormSticky.addEventListener('submit', function (e) {
      var sel = findStickySelector();
      var qty = getPersonasQtyFromSelector(sel);
      if (modalActive || qty >= 2) {
        e.preventDefault();
        abrirModalPersonasSticky();
        return false;
      }
    }, true);
  }

  // Cerrar modal desde overlay o botón
  function closeModal() {
    personasModal.style.display = 'none';
    personasFields.innerHTML = '';
    modalActive = false;
    if (activeForm) {
      var btn = activeForm.querySelector && activeForm.querySelector('button[name="add"]');
      if (btn) btn.disabled = false;
    }
    activeForm = null;
    // re-attach (por si el DOM se re-renderizó)
    setTimeout(attachStickySelectorListener, 100);
  }
  [closeBtn, overlay].forEach(function (el) {
    if (!el) return;
    el.addEventListener('click', closeModal);
  });

  // Submit del modal: valida, guarda en localStorage y envía el form sticky (activeForm)
  if (personasForm) {
    personasForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var sel = findStickySelector();
      var qty = getPersonasQtyFromSelector(sel);
      var valid = true;

      personasForm.querySelectorAll('input,select').forEach(function (input) {
        if (!String(input.value || '').trim()) {
          input.style.borderColor = '#e00';
          valid = false;
        } else {
          input.style.borderColor = '#ccc';
        }
        if (input.type === 'email') {
          var re = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
          if (!re.test(input.value.trim())) {
            input.style.borderColor = '#e00';
            valid = false;
          }
        }
      });
      if (!valid) return;

      var personas = [];
      for (var i = 0; i < qty; i++) {
        personas.push({
          nombre: personasForm['nombre_' + i].value,
          edad: personasForm['edad_' + i].value,
          genero: personasForm['sexo_' + i].value,
          correo: i === 0 ? personasForm['correo_' + i].value : '',
          ocupacion: personasForm['dedica_' + i].value
        });
      }

      // Obtener información del producto para guardarla con los datos
      var productTitle = document.querySelector('h1.product__title')?.textContent.trim() || 
                         document.querySelector('.product__title')?.textContent.trim() || 
                         'Producto';
      var variantId = '';
      
      try {
        if (activeForm) {
          var variantInput = activeForm.querySelector('select[name="id"], input[name="id"][checked], input[name="id"][type="hidden"]');
          if (variantInput) {
            variantId = variantInput.value;
          }
        }
      } catch (e) {
        console.error('Error al obtener variant ID:', e);
      }

      // Guardar en localStorage con información para identificar el producto
      var personasData = {
        producto: productTitle,
        variant_id: variantId,
        timestamp: new Date().toISOString(),
        personas: personas
      };
      
      // Guardar temporalmente con variant_id hasta que tengamos la key del carrito
      if (variantId) {
        localStorage.setItem('personas_pend_' + variantId, JSON.stringify(personasData));
      }

      // cerrar modal, habilitar botón y enviar
      closeModal();
      if (activeForm) {
        var submitBtn = activeForm.querySelector('button[name="add"]');
        if (submitBtn) submitBtn.disabled = false;
        activeForm.submit();
      }
    });
  }

  // Inicializar listener y observar cambios (si el theme re-renderiza el sticky)
  attachStickySelectorListener();
  var observer = new MutationObserver(function () { attachStickySelectorListener(); });
  observer.observe(document.body, { childList: true, subtree: true });
});

  } catch(e) { console.error(e); }
})();
})();
